import { render, staticRenderFns } from "./CreditsToExpire.vue?vue&type=template&id=70f2ce68&"
import script from "./CreditsToExpire.vue?vue&type=script&lang=js&"
export * from "./CreditsToExpire.vue?vue&type=script&lang=js&"
import style0 from "./CreditsToExpire.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports